module.exports = __webpack_public_path__ + "img/full0-min.0a72c1c2.png";